import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useEffect, } from 'preact/hooks'

import Product from './Product'

export default ({ cardWidth }) => {
    const { response: { products }, loading } = useAppState()

    useEffect(() => {
        if(!window.nostojs) return;
        window.nostojs(api => {
            api.loadRecommendations({
                skipPageViews: true, 
                skipEvents: true
            })
        })
    }, []);

    // console.log("products", products);

    return (
        <div
            id="nosto-product-grid" // keep for placement targetting
            class="ns-d-flex ns-flex-wrap"
            style={`${loading ? 'opacity: 0.3;' : ''} --ns-products-width: ${cardWidth}`}
        >
            {products.hits?.map((hit) => (
                <Product product={hit} />
            ))}
        </div>
    )
}
